import * as React from 'react'
import Milliseconds from '../../helper/milliseconds'
import LargeNumber from '../../helper/large-number'

interface Props {
    message?: {
        args: {
            ct: number
            wt: number
        }
    }
}

export default class WpNavMenuBottleneck extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let info = (
            <p>
                The <code>wp_nav_menu</code> function can take a significant portion of the request time
            </p>
        )
        if (message) {
            info = (
                <p>
                    The <code>wp_nav_menu</code> function was called <LargeNumber value={message.args.ct} class="" /> times and took a total
                    of <Milliseconds value={message.args.wt} />, which is a significant portion of the request time.
                </p>
            )
        }
        return (
            <div>
                {info}
                <p>
                    Consider using the <a href="https://github.com/Automattic/cache-nav-menus">Automattic</a> plugin to cache navigation
                    menus.
                </p>
            </div>
        )
    }
}
